import React, { Component } from 'react';
import { observer } from 'mobx-react';
import BranchDueGrid from './BranchDueGrid';
import LabDueGrid from './LabDueGrid';
import LabDetailsGrid from './LabDetailsGrid';

class DueConsolidation extends Component {

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    labDueGridOrLabDetailsGrid = () => {
        if(this.store.selectedLab === undefined)
        {
            return (
                <div style={{ width: '50%' }}>
                    <LabDueGrid store={this.props.store} />
                </div>
            )
        }

        return (
            <div style={{ width: '50%' }}>
                <LabDetailsGrid store={this.props.store} />
            </div>
        )
    }
    render() {

        return (
            <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: "5px" }}>
                <div style={{ width: '50%' }}>
                    <BranchDueGrid store={this.props.store} title="Dues from Branches"/>
                </div>
                { this.labDueGridOrLabDetailsGrid()}
            </div>
        )
    }
}

export default observer(DueConsolidation)
